module.exports = __webpack_public_path__ + "img/资产负债_试算平衡.50902bc5.png";